import {
  DatePicker,
  Modal,
  Image,
  Popconfirm,
  Table,
  Alert,
  Button,
} from "antd";
import React, { useEffect, useState, useContext } from "react";
import { PlusCircle } from "react-feather";
import { ArrowLeft } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

import {
  createEmployeeMethod,
  deleteEmployeeMethod,
  getAllAllowances,
  getAllDepartments,
  getAllDesignations,
  getAllEmployeesMethod,
  getAllShiftsMethod,
  getEmployeeShiftHistory,
} from "../../service/ApiServices";
import moment from "moment";
import Swal from "sweetalert2";
import Select from "react-select";
import "./style.css";
import EmployeeResignModal from "../../core/modals/hrm/employeeResign";
import EmployeeReactivateModal from "../../core/modals/hrm/employeeReactivate";
import EmployeeViewModal from "../../core/modals/hrm/EmployeeView";
import { getSearchEmployees } from "../../service/employeeService";
import BulkUploadModal from "../../core/modals/hrm/bulkupload-employee";
import jsPDF from "jspdf";
import ExcelJS from "exceljs";
import okilogo from "../../assets/OKI-logo.png";
import dayjs from "dayjs";
import { Select as AntSelect } from "antd";
import { getResignationsByEmployeeId } from "../../service/employeeResignService";
import { getAllDepartments as allDepartments } from "../../service/departmentService";
import { getAllowancesByEmployeeId, createEmployeeAllowance, updateEmployeeAllowance, deleteEmployeeAllowance } from "../../service/allowanceService";
import { fetchActiveDeductionTypes } from "../../service/deductionTypeService";
import { createDeductionSilent, editDeduction, deleteDeduction, getDeductionsByEmployeeId } from "../../service/deductionService";
import SearchInput from "../components/SearchBar/SearchInput";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "lucide-react";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";
import HRISIntegration from "../../core/modals/hrm/HRISIntegration";
import { nationalities } from "../../core/json/nationalities";
import EmployeeModal from "../../core/modals/hrm/EmployeeModal";
import { base_path_img } from "../../environment";

const { RangePicker } = DatePicker;

const education_and_training = [
  { value: "educational_qualifications", label: "Educational Qualifications" },
  {
    value: "professional_certifications",
    label: "Professional Certifications",
  },
  { value: "skills_and_competencies", label: "Skills and Competencies" },
];

const employeeCategoryOptions = [
  { value: "Full Time", label: "Full Time" },
  { value: "Part Time", label: "Part Time" },
  { value: "Daily Basics", label: "Daily Basics" },
  { value: "Contract", label: "Contract" }, // Fix capitalization
  { value: "Probation", label: "Probation" }, // Fix capitalization
];

const titleOptions = [
  { value: "Mr", label: "Mr." },
  { value: "Mrs", label: "Mrs." },
  { value: "Miss", label: "Miss." },
  { value: "Ms", label: "Ms." },
  { value: "Rev", label: "Rev." },
  { value: "Dr", label: "Dr." },
];

const gender = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "other", label: "Other" },
];

const center = [
  { value: "OKI", label: "OKI" },
  { value: "OKIDS", label: "OKIDS" },
  { value: "OKIT", label: "OKIT" },
];

const employeeTypes = [
  { value: "Academic", label: "Academic" },
  { value: "Non Academic", label: "Non Academic" },
];

const branchOptions = [
  { value: "wattala", label: "Wattala" },
  { value: "negombo", label: "Negombo" },
  { value: "kaduwela", label: "Kaduwela" },
  { value: "kiribathgoda", label: "Kiribathgoda" },
  { value: "kandana", label: "Kandana" },
  { value: "delgoda", label: "Delgoda" },
  { value: "lsu", label: "Wattala LSU" },
  { value: "cityschool", label: "City School - Negombo" }
];

const payFrequencies = [
  { value: "Monthly", label: "Monthly" },
  { value: "Weekly", label: "Weekly" },
  { value: "Daily", label: "Daily" },
  { value: "annually", label: "Annually" },
];

const sriLankaProvinces = [
  { value: "Western", label: "Western" },
  { value: "Central", label: "Central" },
  { value: "eastern", label: "Eastern" },
  { value: "northern", label: "Northern" },
  { value: "northCentral", label: "North Central" },
  { value: "northWestern", label: "North Western" },
  { value: "sabaragamuwa", label: "Sabaragamuwa" },
  { value: "southern", label: "Southern" },
  { value: "uva", label: "Uva" },
  { value: "western", label: "Western" },
];

const statusOptions = [
  { value: "Active", label: "Active" },
  { value: "Clearance Pending", label: "Clearance Pending" },
  { value: "Payment Pending", label: "Payment Pending" },
  { value: "Resigned", label: "Resigned" },
];

const EmployeesGrid = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [reason, setReason] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [uploadedPic, setUploadedPic] = useState("");
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [allowances, setAllowances] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [isResign, setIsResign] = useState(false);
  const [isReactivate, setIsReactivate] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [record, setRecord] = useState("");
  const [empRecord, setEmpRecord] = useState({});
  const [recordId, setRecordId] = useState(null);
  const [nationalitiesOptions, setNationality] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [totalBasic, setTotalBasic] = useState(null);
  const [budgetaryAllowance, setBudgetaryAllowance] = useState({});
  const [shiftHistory, setShiftHistory] = useState([]);
  const [hasShiftChanged, setHasShiftChanged] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [dataError, setDataError] = useState(null);

  const [employeeData, setEmployeeData] = useState({
    data: [],
    page: 1,
    limit: 5,
    total: 0,
  });

  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    full_name: "",
    nic: "",
    center: "",
    employeeCategory: "",
    title: "",
    email: "",
    contactNumber: "",
    dateOfBirth: null,
    joiningDate: null,
    departmentId: "",
    designationId: "",
    epfNumber: "",
    basicSalary: "",
    employeeId: "",
    branch: "",
    dateOfTermination: "",
    resign_date: "",
    nationality: "",
    shift: "",
    gender: "",
    payFrequency: "",
    allowances: [],
    payeeTaxApplicable: false,
    overtimeEligibility: false,
    emergencyNo1: "",
    emergencyNo2: "",
    address: "",
    city: "",
    province: "",
    accountHolderName: "",
    accountNumber: "",
    bankName: "",
    branchLocation: "",
    taxPayerId: "",
    isTopLevel: false,
    isRosterShift: false,
    shiftHistory: null,
    changeDate: "",
    shiftChangeReason: "",
    selectedDocType: "",
    employeeType: "",
    probationStart: null,
    probationEnd: null,
    marital_status: "Single",
    residenceAddress: "",
    emergency_name: "",
    emergency_relationship: "",
    compensationAllowances: [],
    compensationDeductions: [],
  });

  // Search states
  const [searchEpfNumber, setSearchEpf] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchBranch, setSearchBranch] = useState(null);
  const [searchCenter, setSearchCenter] = useState(null);
  const [resignStatus, setResignStatus] = useState(null);
  const [resignData, setResignData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [empType, setEmpType] = useState(null);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [allowanceData, setAllowanceData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [hrisModalVisible, setHrisModalVisible] = useState(false);
  const [deductionTypes, setDeductionTypes] = useState([]);
  const [compensationData, setCompensationData] = useState({ allowances: [], deductions: [] });
  const [allowanceCategories, setAllowanceCategories] = useState([]);
  const [deductionCategories, setDeductionCategories] = useState([]);

  // Load employee data function
  const loadEmployeeData = async (params = { page: 1, limit: 5 }, search = "") => {
    try {
      setDataError(null);
      await getAllEmployeesMethod({
        setEmployeeData,
        setLoading: setLoading3,
        params,
        search,
      });
    } catch (error) {
      console.error("Error loading employee data:", error);
      setDataError("Failed to load employee data. Please try again.");
      showWarning("Failed to load employee data");
    }
  };

  // Initial data loading
  useEffect(() => {
    const initialCalls = async () => {
      try {
        fetchNationalities();
        getAllShiftsMethod({ setShiftData: setShifts });
        let data = await getAllAllowances({
          search: "",
          setLoading: setLoading5,
        });
        const mappedAllowances = data.map((item) => ({
          label: item.name,
          value: item._id,
        }));
        setAllowances(mappedAllowances);
        setAllowanceCategories(mappedAllowances);

        // Fetch deduction types for Compensation step
        try {
          const dtResponse = await fetchActiveDeductionTypes();
          const dTypes = dtResponse?.data?.deduction || [];
          setDeductionTypes(dTypes);
          setDeductionCategories(
            dTypes.map((item) => ({
              label: item.deducitionType || item.deductionTypeName || item.name,
              value: item._id,
            }))
          );
        } catch (err) {
          console.error("Error fetching deduction types:", err);
        }
        getAllDesignations({
          search: "",
          setData: setDesignations,
          setLoading: setLoading2,
        });
        getAllDepartments({
          search: "",
          setData: setDepartments,
          setLoading: setLoading2,
        });

        // Load employee data on initial mount only if NOT coming from dashboard
        // Dashboard navigation will trigger its own search
        if (!location.state?.fromDashboard) {
          loadEmployeeData();
        }

        // Load allowance and deduction categories dynamically
        try {
          const deductionTypes = await fetchActiveDeductionTypes();
          // API response shape: { status, data: { deduction: [...] } }
          const deductionArray = deductionTypes?.data?.deduction || [];
          if (deductionArray.length > 0) {
            setDeductionCategories(
              deductionArray.map((item) => ({
                label: item.deducitionType || item.deductionTypeName || item.name,
                value: item._id,
              }))
            );
          }
        } catch (err) {
          console.error("Error loading deduction categories:", err);
        }
      } catch (error) {
        console.error("Error in initial data loading:", error);
        setDataError("Failed to initialize data. Please refresh the page.");
      }
    };
    initialCalls();
  }, []);

  // Handle branch filter from dashboard navigation
  useEffect(() => {
    // Handle new dashboard state format (simpler branch filter)
    if (location.state?.fromDashboard && location.state?.branch) {
      const branchValue = location.state.branch;
      console.log('Dashboard navigation received - branch:', branchValue);

      // Find the branch option
      const branchOption = branchOptions.find(b => b.value === branchValue);

      // Set the filter in state
      setSearchBranch(branchOption || null);

      // Trigger search immediately without resetting employeeData first
      (async () => {
        const records = await getSearchEmployees({
          setLoading: setLoading3,
          status: 'Active', // Only show active employees from dashboard
          epf_number: '',
          name: '',
          center: null,
          branch: branchValue,
          startDate: null,
          endDate: null,
          departmentName: null,
          employee_type: null,
          page: 1,
          limit: 5,
        });

        if (records) {
          setEmployeeData(records);
        } else {
          setEmployeeData({
            data: [],
            page: 1,
            limit: 5,
            total: 0,
          });
        }
      })();

      // Clear navigation state
      window.history.replaceState({}, document.title);
    }
    // Handle old dashboard state format (with filterBranch and filterCenter)
    else if (location.state?.filterBranch && location.state?.fromDashboard) {
      const branchOption = location.state.filterBranch;
      const centerValue = location.state.filterCenter;

      console.log('Dashboard filter received:', { branchOption, centerValue, branchLabel: location.state.branchLabel }); // Debug log

      // Find the center option
      const centerOption = center.find(c => c.value === centerValue);
      console.log('Center option found:', centerOption); // Debug log

      // Set the filters in state
      setSearchBranch(branchOption);
      setSearchCenter(centerOption || null);
      setResignStatus({ value: 'Active', label: 'Active' }); // Set status to Active

      // Trigger search immediately without resetting employeeData first
      (async () => {
        console.log('Executing search with:', { branch: branchOption, center: centerOption }); // Debug log

        const records = await getSearchEmployees({
          setLoading: setLoading3,
          status: 'Active',
          epf_number: '',
          name: '',
          center: centerOption?.value || null,
          branch: branchOption?.value || null,
          startDate: null,
          endDate: null,
          departmentName: null,
          employee_type: null,
          page: 1,
          limit: 5,
        });

        console.log('Search results:', records); // Debug log

        if (records) {
          setEmployeeData(records);
        } else {
          setEmployeeData({
            data: [],
            page: 1,
            limit: 5,
            total: 0,
          });
        }
      })();

      // Clear navigation state to prevent re-triggering
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        const department = await allDepartments({ search: "" });
        const dptOptions = department.map((item) => ({
          value: item.departmentName,
          label: item.departmentName,
        }));
        setDepartmentOptions(dptOptions);
      } catch (error) {
        console.error("Error in fetching Service Names", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLeaveTypes();
  }, []);

  // Handle success and delete states
  useEffect(() => {
    if (success) {
      // Save compensation allowances after employee is saved (edit mode only - we have the ID)
      if (isEdit && formData.employeeId && formData.compensationAllowances) {
        const validAllowances = (formData.compensationAllowances || []).filter(
          (a) => a.allowanceType && a.amount && a.effectiveDate
        );
        validAllowances.forEach((a) => {
          if (!a._id) {
            createEmployeeAllowance(formData.employeeId, a.allowanceType, a.amount, a.effectiveDate)
              .catch((err) => console.error("Error saving allowance:", err));
          }
        });
      }

      // Save compensation deductions
      if (formData.employeeId && formData.compensationDeductions) {
        const validDeductions = (formData.compensationDeductions || []).filter(
          (d) => d.deductionType && d.amount && d.effectiveDate
        );
        validDeductions.forEach((d) => {
          if (!d._id) {
            createDeductionSilent({
              employee: formData.employeeId,
              parentId: d.deductionType,
              amount: Number(d.amount),
              paymentType: d.category || "One-time",
              deduction_date: d.effectiveDate,
              is_active: true,
            }).catch((err) => console.error("Error saving deduction:", err));
          }
        });
      }
      showSuccess("Successfully saved employee!");
      handleCancel();
    }
    if (isDeleted) {
      showSuccess("Successfully disabled employee!");
      setRecord("");
      setReason("");
      setIsModalOpen2(false);
    }
    if (isDeleted || success) {
      loadEmployeeData(
        { page: employeeData.page, limit: employeeData.limit },
        ""
      );
    }
  }, [success, isDeleted]);

  // Handle resignation modal close and refresh data
  useEffect(() => {
    if (isResign === false && empRecord._id) {
      // Reload employee data after resignation process
      loadEmployeeData(
        { page: employeeData.page, limit: employeeData.limit },
        ""
      );
      // Clear the employee record
      setEmpRecord({});
    }
  }, [isResign]);

  const handleReloadData = () => {
    console.log(isView, setPreviewFile)
    loadEmployeeData(
      { page: employeeData.page, limit: employeeData.limit },
      ""
    );
  };

  const handleChangeDepartment = (value) => {
    setSelectedDepartment(value);
  };

  const searchEmployees = async () => {
    const records = await getSearchEmployees({
      setLoading: setLoading3,
      status: resignStatus,
      epf_number: searchEpfNumber,
      name: searchName,
      center: searchCenter,
      branch: searchBranch,
      startDate,
      endDate,
      departmentName: selectedDepartment?.value,
      employee_type: empType,
      page: employeeData.page,
      limit: employeeData.limit,
    });

    if (records) {
      setEmployeeData(records);
    } else {
      setEmployeeData({
        data: [],
        page: 1,
        limit: 5,
        total: 0,
      });
    }
  };

  const handleSearch = async () => {
    try {
      searchEmployees();
    } catch (error) {
      console.error("Error during search:", error);
    }
  };

  const onChange = (dates, dateStrings) => {
    if (dateStrings && dateStrings[0] && dateStrings[1]) {
      setStartDate(dateStrings[0]);
      setEndDate(dateStrings[1]);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const handleResignStatusChange = (status) => {
    setResignStatus(status);
    if (status === "Active") {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const handleResign = async (record) => {
    try {
      console.log("Opening resignation modal for:", record.full_name); // Debug log
      setLoading3(true);

      // Fetch any additional data needed for resignation
      try {
        const resignRecords = await getResignationsByEmployeeId(record._id);
        setResignData(resignRecords?.data || []);
      } catch (error) {
        console.warn("Could not fetch resignation records:", error);
        setResignData([]);
      }

      // Set the employee record and open modal
      setEmpRecord(record);
      setRecordId(record._id);
      setIsResign(true); // This should open the modal

      console.log("Resignation modal should now be open"); // Debug log
    } catch (error) {
      console.error("Error preparing resignation data:", error);
      showWarning("Error loading resignation data");
    } finally {
      setLoading3(false);
    }
  };

  const handleResignationSuccess = () => {
    console.log("Resignation successful, refreshing data"); // Debug log
    // Refresh employee data after successful resignation
    loadEmployeeData(
      { page: employeeData.page, limit: employeeData.limit },
      ""
    );
    // Close resignation modal
    setIsResign(false);
    setEmpRecord({});
    setRecordId(null);
  };

  // FIXED: Handle resignation modal close
  const handleResignationClose = () => {
    console.log("Closing resignation modal"); // Debug log
    setIsResign(false);
    setEmpRecord({});
    setRecordId(null);
  };

  // Handle reactivate employee
  const handleReactivate = async (record) => {
    try {
      console.log("Opening reactivate modal for:", record.full_name);
      setLoading3(true);

      // Fetch resignation records
      try {
        const resignRecords = await getResignationsByEmployeeId(record._id);
        setResignData(resignRecords?.data || []);
      } catch (error) {
        console.warn("Could not fetch resignation records:", error);
        setResignData([]);
      }

      // Set the employee record and open modal
      setEmpRecord(record);
      setRecordId(record._id);
      setIsReactivate(true);

      console.log("Reactivate modal should now be open");
    } catch (error) {
      console.error("Error preparing reactivation data:", error);
      showWarning("Error loading reactivation data");
    } finally {
      setLoading3(false);
    }
  };

  const handleReactivateSuccess = () => {
    console.log("Reactivation successful, refreshing data");
    // Refresh employee data after successful reactivation
    loadEmployeeData(
      { page: employeeData.page, limit: employeeData.limit },
      ""
    );
    // Close reactivate modal
    setIsReactivate(false);
    setEmpRecord({});
    setRecordId(null);
  };

  const handleReactivateClose = () => {
    console.log("Closing reactivate modal");
    setIsReactivate(false);
    setEmpRecord({});
    setRecordId(null);
  };

  const handlePdfExport = async () => {
    try {
      setLoading3(true);
      const records = await getSearchEmployees({
        setLoading: () => {},
        status: resignStatus,
        epf_number: searchEpfNumber,
        name: searchName,
        center: searchCenter,
        branch: searchBranch,
        startDate,
        endDate,
        departmentName: selectedDepartment?.value,
        employee_type: empType,
        withoutPagination: true,
      });

      setLoading3(false);

      if (!records || !records.data || records.data.length === 0) {
        showWarning("No employees found to export");
        return;
      }

      const date = dayjs().format("YYYY-MM-DD");
      const img = okilogo;

      const doc = new jsPDF({ orientation: "landscape" });
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(16);
      doc.text("OKI International ", 15, 13);
      doc.setFontSize(13);
      doc.setTextColor(138, 132, 125);
      doc.text(`Employees List`, 15, 23);
      doc.text(`Date: ${date}`, 15, 30);
      doc.addImage(img, "PNG", 260, 8, 22, 25);
      doc.autoTable({
        head: [
          [
            "EPF No.",
            "Employee Name",
            "Employee Type",
            "NIC",
            "Contact Number",
            "Branch",
            "Center",
            "Department",
            "Designation",
            "Shift",
            "Join Date",
            "Basic Salary",
            "Status",
          ],
        ],
        body: records.data.map((emp) => [
          emp.epf_number || "N/A",
          emp.full_name || `${emp.first_name || ""} ${emp.last_name || ""}`.trim() || "N/A",
          emp.employee_type || "N/A",
          emp.nic || "N/A",
          emp.contact_number || "N/A",
          emp.branch || "N/A",
          emp.center || "N/A",
          emp.department ? emp.department.departmentName : "N/A",
          emp.designation ? emp.designation.designationName : "N/A",
          emp.shift ? emp.shift.shiftName : "N/A",
          emp.joining_date ? moment(emp.joining_date).format("YYYY-MM-DD") : "N/A",
          emp.basic_salary !== undefined ? emp.basic_salary.toLocaleString() : "0",
          emp.status || "N/A",
        ]),
        startY: 35,
        theme: "striped",
        headStyles: {
          fillColor: [138, 132, 125],
        },
      });
      doc.save("employees_list.pdf");
    } catch (error) {
      setLoading3(false);
      console.error("PDF export error:", error);
      showWarning("Failed to export PDF");
    }
  };

  const handleExcelExport = async () => {
    try {
      setLoading3(true);
      const records = await getSearchEmployees({
        setLoading: () => {},
        status: resignStatus,
        epf_number: searchEpfNumber,
        name: searchName,
        center: searchCenter,
        branch: searchBranch,
        startDate,
        endDate,
        departmentName: selectedDepartment?.value,
        employee_type: empType,
        withoutPagination: true,
      });

      setLoading3(false);

      if (!records || !records.data || records.data.length === 0) {
        showWarning("No employees found to export");
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Employees Report");

      const borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      worksheet.columns = [
        { header: "EPF No.", key: "epfNumber", width: 15 },
        { header: "Employee Name", key: "fullName", width: 25 },
        { header: "Employee Type", key: "employeeType", width: 20 },
        { header: "NIC", key: "nic", width: 20 },
        { header: "Contact Number", key: "phone", width: 20 },
        { header: "Branch", key: "branch", width: 20 },
        { header: "Center", key: "center", width: 20 },
        { header: "Department", key: "department", width: 25 },
        { header: "Designation", key: "designation", width: 25 },
        { header: "Shift", key: "shift", width: 20 },
        { header: "Join Date", key: "joinDate", width: 15 },
        { header: "Basic Salary", key: "basicSalary", width: 15 },
        { header: "Status", key: "status", width: 15 },
      ];

      records.data.forEach((emp) => {
        worksheet.addRow({
          epfNumber: emp.epf_number || "N/A",
          fullName: emp.full_name || `${emp.first_name || ""} ${emp.last_name || ""}`.trim() || "N/A",
          employeeType: emp.employee_type || "N/A",
          nic: emp.nic || "N/A",
          phone: emp.contact_number || "N/A",
          branch: emp.branch || "N/A",
          center: emp.center || "N/A",
          department: emp.department ? emp.department.departmentName : "N/A",
          designation: emp.designation ? emp.designation.designationName : "N/A",
          shift: emp.shift ? emp.shift.shiftName : "N/A",
          joinDate: emp.joining_date ? moment(emp.joining_date).format("YYYY-MM-DD") : "N/A",
          basicSalary: emp.basic_salary !== undefined ? emp.basic_salary : 0,
          status: emp.status || "N/A",
        });
      });

      worksheet.eachRow({ includeEmpty: true }, (row) => {
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.border = borderStyle;
        });
      });

      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Employees_Report.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
      });
    } catch (error) {
      setLoading3(false);
      console.error("Excel export error:", error);
      showWarning("Failed to export Excel file");
    }
  };

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const setDataFunc = async (record, isEdit) => {
    const employeeId = record._id;

    setShiftHistory([]);
    setUploadedPic(record?.profile_image_url ? `${base_path_img}${record?.profile_image_url}` : "/placeholder.svg");
    setDocuments([]);
    setResignData([]);
    setAllowanceData([]);
    setTotalBasic(null);
    setBudgetaryAllowance({});

    let shiftHistoryData = [];
    if (
      record.shiftHistory?.length > 0 &&
      typeof record.shiftHistory[0] === "object" &&
      record.shiftHistory[0]._id
    ) {
      shiftHistoryData = record.shiftHistory;
    } else {
      if (!isEdit) {
        try {
          const resignRecords = await getResignationsByEmployeeId(employeeId);
          setResignData(resignRecords?.data || []);

          const allowanceRes = await getAllowancesByEmployeeId(employeeId);
          setAllowanceData(allowanceRes || []);

          const budgetart = calculateBudgetaryAllowance(record.basic_salary);
          const sumOfBasic = calculateTotalBasicWithAllowances(
            budgetart.totalAllowance,
            record.basic_salary
          );
          setTotalBasic(sumOfBasic);
          setBudgetaryAllowance(budgetart);

          const shiftHistoryResponse = await getEmployeeShiftHistory(employeeId);
          shiftHistoryData = Array.isArray(shiftHistoryResponse)
            ? shiftHistoryResponse
            : [];
        } catch (error) {
          console.error("Error fetching view data:", error);
          shiftHistoryData = [];
        }
      } else {
        // Edit mode: pre-load existing compensation data
        try {
          const allowanceRes = await getAllowancesByEmployeeId(employeeId);
          if (allowanceRes && allowanceRes.length > 0) {
            const mappedAllowances = allowanceRes.map((a) => ({
              _id: a._id,
              allowanceType: a.allowanceType?._id || a.allowanceType || "",
              category: a.category || "",
              amount: a.amount || "",
              effectiveDate: a.effectiveDate ? a.effectiveDate.split("T")[0] : "",
            }));
            setFormData((prev) => ({ ...prev, compensationAllowances: mappedAllowances }));
          }
        } catch (error) {
          console.error("Error pre-loading allowances for edit:", error);
        }
      }
    }
    setShiftHistory(shiftHistoryData);

    const docArray = [];
    if (record.qualifications_doc_urls?.length > 0) {
      record.qualifications_doc_urls.forEach((url) => {
        docArray.push({
          type: "educational_qualifications",
          url,
          name: url.split("/").pop(),
        });
      });
    }
    if (record.certifications_doc_urls?.length > 0) {
      record.certifications_doc_urls.forEach((url) => {
        docArray.push({
          type: "professional_certifications",
          url,
          name: url.split("/").pop(),
        });
      });
    }
    if (record.skills_doc_urls?.length > 0) {
      record.skills_doc_urls.forEach((url) => {
        docArray.push({
          type: "skills_and_competencies",
          url,
          name: url.split("/").pop(),
        });
      });
    }
    setDocuments(docArray);

    setFormData({
      accountNumber: record?.account_number || "",
      branch: record?.branch || "",
      title: record?.title || "",
      full_name:
        record?.full_name ||
        `${record?.first_name || ""} ${record?.last_name || ""}`,
      email: record?.email || "",
      nic: record?.nic || "",
      contactNumber: record?.contact_number || "",
      dateOfBirth: record?.date_of_birth
        ? moment(record.date_of_birth, "YYYY-MM-DD").isValid()
          ? record.date_of_birth.split("T")[0]
          : null
        : null,
      joiningDate: record?.joining_date
        ? moment(record.joining_date, "YYYY-MM-DD").isValid()
          ? record.joining_date.split("T")[0]
          : null
        : null,
      departmentId: record?.department_id || "",
      department: record?.department || null,
      designation: record?.designation || null,
      designationId: record?.designation_id || "",
      epfNumber: record?.epf_number || "",
      basicSalary: record?.basic_salary
        ? parseFloat(record.basic_salary).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        : "",
      workLocation: record?.work_location || "",
      dateOfTermination: record?.date_of_termination
        ? record.date_of_termination.split("T")[0]
        : "",
      resign_date: record?.resign_date
        ? moment(record.resign_date).format("YYYY-MM-DD")
        : "",
      nationality: record?.nationality || "",
      shift: record?.shift?._id || "",
      bloodGroup: record?.blood_group || "",
      gender: record?.gender || "",
      center: record?.center || "",
      employeeType: record?.employee_type || "",
      contractPeriod: record?.contract_period
        ? record.contract_period.split(",")
        : "",
      employeeCategory: record?.employeeCategory || "",
      jobGrade: record?.job_grade || "",
      payFrequency: record?.pay_frequency || "",
      payeeTaxApplicable: record?.payee_tax_applicable || false,
      overtimeEligibility: record?.overtime_eligibility || false,
      emergencyNo1: record?.emergency_no_1 || "",
      emergencyNo2: record?.emergency_no_2 || "",
      address: record?.address || "",
      city: record?.city || "",
      province: record?.province || "",
      employeeId: record._id,
      bankName: record?.bank || "",
      accountHolderName: `${record?.first_name} ${record?.last_name}` || "",
      branchLocation: record?.branch_code || "",
      isTopLevel: record?.isTopLevel || false,
      isRosterShift: record?.isRosterShift || false,
      shiftHistory: shiftHistoryData,
      shiftChangeReason: "",
      changeDate: "",
      selectedDocType: "",
      marital_status: record?.marital_status,
      residenceAddress: record?.residenceAddress,
      emergency_name: record?.emergency_name,
      emergency_relationship: record?.emergency_relationship,
      probationStart: record?.probationStart
        ? record.probationStart.split("T")[0]
        : null,
      probationEnd: record?.probationEnd
        ? record.probationEnd.split("T")[0]
        : null,
    });

    setRecord(record);

    if (isEdit) {
      setIsEdit(true);
      setIsView(false);
      setIsModalOpen(true);

      // Pre-load existing allowances and deductions for edit mode
      (async () => {
        try {
          const [allowancesRes, deductionsRes] = await Promise.all([
            getAllowancesByEmployeeId(employeeId),
            getDeductionsByEmployeeId(employeeId)
          ]);
          
          const mappedAllowances = (allowancesRes || []).map((a) => ({
            _id: a._id,
            allowanceTypeId: a.allowanceType?._id || a.allowanceType || "",
            allowanceTypeName: a.allowanceType?.name || "",
            amount: a.amount || 0,
            effectiveDate: a.effectiveDate ? a.effectiveDate.split("T")[0] : "",
          }));
          
          const mappedDeductions = (deductionsRes || []).map((d) => ({
            _id: d._id,
            deductionTypeId: d.parentId?._id || d.parentId || "",
            deductionTypeName: d.parentId?.deducitionType || "",
            amount: d.amount || 0,
            effectiveDate: d.deduction_date ? d.deduction_date.split("T")[0] : "",
            paymentType: d.paymentType || "oneTime",
          }));
          
          setCompensationData({
            allowances: mappedAllowances,
            deductions: mappedDeductions
          });
        } catch (error) {
          console.error("Error pre-loading compensation data for edit:", error);
        }
      })();
    } else {
      setIsEdit(false);
      setIsView(true);
      setIsViewModalOpen(true);
    }
  };

  const calculateBudgetaryAllowance = (basic_salary) => {
    let allowance1000 = 0;
    let allowance2500 = 0;
    let totalAllowance = 0;

    if (basic_salary < 25000) {
      allowance1000 = 1000;
      allowance2500 = 2500;
      totalAllowance = allowance1000 + allowance2500;
    } else if (basic_salary <= 40000) {
      allowance2500 = 2500;
      totalAllowance = allowance2500;
    }
    return {
      allowance1000,
      allowance2500,
      totalAllowance,
    };
  };

  const calculateTotalBasicWithAllowances = (basic_salary, bAllowance) => {
    return basic_salary + bAllowance;
  };

  const fetchNationalities = () => {
    try {
      setNationality(nationalities);
    } catch (error) {
      console.error("Error setting nationalities:", error);
    }
  };

  const handleTableChange = (pagination) => {
    const newEmployeeData = {
      ...employeeData,
      page: pagination.current,
      limit: pagination.pageSize,
    };
    setEmployeeData(newEmployeeData);

    // Check if any search filters are active
    const hasActiveFilters = searchBranch || searchCenter || searchName || searchEpfNumber ||
      resignStatus || startDate || endDate || selectedDepartment || empType;

    if (hasActiveFilters) {
      // Use search with filters - pass the new page and limit
      searchEmployeesWithPagination(pagination.current, pagination.pageSize);
    } else {
      // Use normal load without filters
      loadEmployeeData(
        { page: pagination.current, limit: pagination.pageSize },
        ""
      );
    }
  };

  const searchEmployeesWithPagination = async (page, limit) => {
    const records = await getSearchEmployees({
      setLoading: setLoading3,
      status: resignStatus,
      epf_number: searchEpfNumber,
      name: searchName,
      center: searchCenter,
      branch: searchBranch,
      startDate,
      endDate,
      departmentName: selectedDepartment?.value,
      employee_type: empType,
      page: page || employeeData.page,
      limit: limit || employeeData.limit,
    });

    if (records) {
      setEmployeeData(records);
    } else {
      setEmployeeData({
        data: [],
        page: 1,
        limit: 5,
        total: 0,
      });
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setCompensationData({ allowances: [], deductions: [] });
    handleReset();
  };

  const handleResetAllFilters = () => {
    // Reset all search filters
    setSearchEpf("");
    setSearchName("");
    setSearchBranch(null);
    setSearchCenter(null);
    setResignStatus(null);
    setStartDate(null);
    setEndDate(null);
    setSelectedDepartment(null);
    setEmpType(null);

    // Reset pagination to page 1
    setEmployeeData({
      ...employeeData,
      page: 1,
    });

    // Load all employees
    loadEmployeeData({ page: 1, limit: employeeData.limit }, "");
  };

  const handleReset = () => {
    setFormData({
      // Personal & contact
      full_name: "",
      title: "",
      nic: "",
      center: "",
      branch: "",
      email: "",
      contactNumber: "",
      dateOfBirth: null,
      gender: "",
      nationality: "",
      bloodGroup: "",
      marital_status: "Single",
      // Employment
      employeeCategory: "",
      employeeType: "",
      employeeId: "",
      epfNumber: "",
      departmentId: "",
      designationId: "",
      joiningDate: null,
      dateOfTermination: "",
      resign_date: "",
      shift: "",
      payFrequency: "",
      basicSalary: "",
      jobGrade: "",
      contractPeriod: "",
      workLocation: "",
      isTopLevel: false,
      isRosterShift: false,
      payeeTaxApplicable: false,
      overtimeEligibility: false,
      probationStart: null,
      probationEnd: null,
      // Bank — cleared independently from Branch on page 1
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      branchLocation: "",   // ← was missing — caused NIC/branch bleed into this field
      taxPayerId: "",
      // Address
      address: "",
      residenceAddress: "",
      city: "",
      province: "",
      // Emergency
      emergency_name: "",
      emergency_relationship: "",
      emergencyNo1: "",
      emergencyNo2: "",
      // Compensation
      allowances: [],
      compensationAllowances: [],
      compensationDeductions: [],
      // Shift change
      shiftChangeReason: "",
      changeDate: "",
      shiftHistory: null,
      selectedDocType: "",
      // Auth
      password: "",
      conformPassword: "",
    });
    setFileList([]);
    setPreviewImage("");
    setUploadedPic("");
    setIsEdit(false);
    setIsView(false);
    setDocuments([]);
    setHasShiftChanged(false);
    setDataError(null);
  };


  const showSuccess = (str) => {
    return Swal.fire({
      title: "Good job!",
      text: str,
      icon: "success",
    });
  };

  const showWarning = (str) => {
    return Swal.fire({
      title: "Error",
      text: str,
      icon: "error",
    });
  };

  // Handle employee form submission
  const handleEmployeeSubmit = async () => {
    const formDataToSend = new FormData();

    Object.keys(formData).forEach((key) => {
      if (key === "allowances") {
        formDataToSend.append(
          key,
          JSON.stringify(
            formData[key].map((item) => ({
              name: item.id.value || item.id,
              amount: item.amount,
            }))
          )
        );
        return;
      }
      // Skip compensation rows - saved separately via allowance/deduction API
      if (key === "compensationAllowances" || key === "compensationDeductions") {
        return;
      }
      if (key !== "selectedDocType" && key !== "shiftHistory") {
        if (key === "shiftChangeReason" && formData.shift === record?.shift?._id) {
          return;
        }
        if (key === "changeDate" && formData.shift === record?.shift?._id) {
          return;
        }
        if (["probationStart", "probationEnd"].includes(key) &&
          !["Contract", "Probation"].includes(formData.employeeCategory)) {
          return;
        }
        let val = formData[key] || "";
        // Strip comma formatting from salary before sending
        if (key === "basicSalary" && typeof val === "string") {
          val = val.replace(/,/g, "");
        }
        formDataToSend.append(key, val);
      }
    });

    if (fileList.length > 0) {
      formDataToSend.append("profilePicture", fileList[0]);
    }

    education_and_training.forEach((type) => {
      const docsOfType = documents.filter((doc) => doc.type === type.value);
      docsOfType.forEach((doc) => {
        if (doc.originFileObj) {
          formDataToSend.append(type.value, doc.originFileObj);
        }
      });
    });

    // Log formDataToSend entries for debugging at the very end
    console.log("Submitting Employee FormData:");
    for (let [key, value] of formDataToSend.entries()) {
      if (value instanceof File || value instanceof Blob) {
        console.log(`FormData: ${key} = [File: ${value.name}]`);
      } else {
        console.log(`FormData: ${key} = ${value}`);
      }
    }

    const result = await createEmployeeMethod({
      formdata: formDataToSend,
      setLoading,
      setSuccess,
    });

    // Save or sync compensation data
    const empId = result?.employee?._id || result?._id || formData.employeeId;
    if (empId) {
      console.log("Saving / Syncing compensation data for employee ID:", empId);

      // --- ALLOWANCES SYNC ---
      try {
        // Fetch current allowances from DB
        const currentAllowances = await getAllowancesByEmployeeId(empId) || [];
        
        // Find allowances to delete (exist in DB but not in new compensationData)
        const allowancesToDelete = currentAllowances.filter(
          (dbItem) => !compensationData.allowances.some((newItem) => newItem._id === dbItem._id)
        );
        for (const item of allowancesToDelete) {
          try {
            await deleteEmployeeAllowance(item._id);
          } catch (err) {
            console.error("Error deleting allowance:", err);
          }
        }

        // Create or update allowances
        if (compensationData.allowances && compensationData.allowances.length > 0) {
          for (const allowance of compensationData.allowances) {
            if (allowance._id) {
              // Existing - update
              await updateEmployeeAllowance(
                allowance._id,
                empId,
                allowance.allowanceTypeId,
                allowance.amount,
                allowance.effectiveDate
              );
            } else {
              // New - create
              await createEmployeeAllowance(
                empId,
                allowance.allowanceTypeId,
                allowance.amount,
                allowance.effectiveDate
              );
            }
          }
        }
      } catch (err) {
        console.error("Error syncing allowances:", err);
      }

      // --- DEDUCTIONS SYNC ---
      try {
        // Fetch current deductions from DB
        const currentDeductions = await getDeductionsByEmployeeId(empId) || [];

        // Find deductions to delete (exist in DB but not in new compensationData)
        const deductionsToDelete = currentDeductions.filter(
          (dbItem) => !compensationData.deductions.some((newItem) => newItem._id === dbItem._id)
        );
        for (const item of deductionsToDelete) {
          try {
            await deleteDeduction({ id: item._id });
          } catch (err) {
            console.error("Error deleting deduction:", err);
          }
        }

        // Create or update deductions
        if (compensationData.deductions && compensationData.deductions.length > 0) {
          for (const deduction of compensationData.deductions) {
            if (deduction._id) {
              // Existing - update
              await editDeduction(deduction._id, {
                amount: deduction.amount,
                parentId: deduction.deductionTypeId,
                employee: empId,
                paymentType: deduction.paymentType,
                deduction_date: deduction.effectiveDate,
              });
            } else {
              // New - create
              await createDeductionSilent({
                amount: deduction.amount,
                parentId: deduction.deductionTypeId,
                employee: empId,
                paymentType: deduction.paymentType,
                deduction_date: deduction.effectiveDate,
              });
            }
          }
        }
      } catch (err) {
        console.error("Error syncing deductions:", err);
      }

      // Clear compensation data
      setCompensationData({ allowances: [], deductions: [] });
    }
  };

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const columns = [
    {
      title: "Employee",
      key: "employee",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Image
            src={record.profile_image_url ? `${base_path_img}${record.profile_image_url}` : "/placeholder.svg"}
            alt="Profile Picture"
            width={50}
            height={50}
            style={{
              borderRadius: "100%",
              objectFit: "cover",
            }}
            preview={{
              zIndex: 10000,
              visible: previewOpen,
              src: previewImage,
              onVisibleChange: (visible) => setPreviewOpen(visible),
            }}
            onClick={() => {
              setPreviewImage(record.profile_image_url ? `${base_path_img}${record.profile_image_url}` : "/placeholder.svg");
              setPreviewOpen(true);
            }}
          />
          <span>
            {record.full_name
              ? record.full_name
              : `${record.first_name} ${record.last_name}`}
          </span>
        </div>
      ),
    },
    {
      title: "NIC",
      key: "nic",
      render: (text, record) => (record.nic ? record.nic : "N/A"),
    },
    {
      title: "EPF",
      dataIndex: "epf_number",
      key: "employee_id",
    },
    {
      title: "Join Date",
      dataIndex: "joining_date",
      key: "joining_date",
    },
    {
      title: "Designation",
      dataIndex: ["designation", "designationName"],
      key: "designation.designationName",
    },
    {
      title: "Shift",
      dataIndex: ["shift", "shiftName"],
      key: "shift.shiftName",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span
          className={`badge ${status === "Active" ? "badge-linesuccess" : "badge-linedanger"
            }`}
          style={{ width: 80, padding: 6 }}
        >
          <Link to="#" style={{ cursor: "default", fontSize: 14 }}>
            {status}
          </Link>
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <td className="action-table-data">
          <Link
            className="me-2 p-2"
            onClick={() => {
              setDataFunc(record, false);
            }}
          >
            <i data-feather="download" className="feather-eye"></i>
          </Link>

          <Link
            className={`me-2 p-2 ${user?.permissions &&
              hasPermission(user.permissions, "HRM", "Employee", "edit")
              ? ""
              : "disabled"
              }`}
            onClick={() => {
              if (
                user?.permissions &&
                hasPermission(user.permissions, "HRM", "Employee", "edit")
              ) {
                setDataFunc(record, true);
              }
            }}
            title={
              !hasPermission(user?.permissions, "HRM", "Employee", "edit")
                ? "No edit permission"
                : ""
            }
          >
            <i data-feather="download" className="feather-edit"></i>
          </Link>

          {record.status !== "Resigned" ? (
            <Link
              className="me-2 p-2"
              title="Resign"
              onClick={() => handleResign(record)}
            >
              <i data-feather="download" className="feather-user-minus"></i>
            </Link>
          ) : (
            <Link
              className="me-2 p-2"
              title="Reactivate Employee"
              onClick={() => handleReactivate(record)}
            >
              <RotateCcw size={16} color="#FF9500" />
            </Link>
          )}

          <Popconfirm
            title="Delete the Employee"
            description="Are you sure to disable this Employee?"
            onConfirm={() => {
              if (
                user?.permissions &&
                hasPermission(user.permissions, "HRM", "Employee", "delete")
              ) {
                setIsModalOpen2(true);
                setRecord(record);
              }
            }}
            disabled={
              !(
                user?.permissions &&
                hasPermission(user.permissions, "HRM", "Employee", "delete")
              )
            }
          >
            <Link
              className={`confirm-text p-2 ${user?.permissions &&
                hasPermission(user.permissions, "HRM", "Employee", "delete")
                ? ""
                : "disabled"
                }`}
              title={
                !(
                  user?.permissions &&
                  hasPermission(user.permissions, "HRM", "Employee", "delete")
                )
                  ? "No delete permission"
                  : ""
              }
            >
              <i data-feather="x-circle" className="feather-x-circle"></i>
            </Link>
          </Popconfirm>
        </td>
      ),
    },
  ];

  return (
    <div className="page-wrapper" style={{ backgroundColor: "#fff" }}>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container ">
              <div>
                <ArrowLeft size={32} />
              </div>
              <div className="page-title">
                <h4>Employees</h4>
                <h6>Manage your Employees</h6>
              </div>
            </div>
          </div>

          <div className="header-container-top">
            <div className="top-row">
              <div className="wordset">
                <ul>
                  <li>
                    <a
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="pdf"
                      onClick={handlePdfExport}
                    >
                      <img src="assets/img/icons/pdf.svg" alt="pdf" />
                    </a>
                  </li>
                  <li>
                    <a
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="excel"
                      onClick={handleExcelExport}
                    >
                      <img src="assets/img/icons/excel.svg" alt="excel" />
                    </a>
                  </li>
                  {user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "HRM",
                      "Employee",
                      "print"
                    ) && (
                      <li>
                        <a
                          href="#"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="print"
                        >
                          <img src="assets/img/icons/printer.svg" alt="print" />
                        </a>
                      </li>
                    )}
                  <div className="page-btn"
                  // style={{ display: "none" }}
                  >
                    <a
                      className="btn btn-added"
                      onClick={() => setHrisModalVisible(true)}
                    >
                      HRIS Integration
                    </a>
                  </div>
                </ul>
              </div>
            </div>
            <div className="bottom-row">
              <div style={{ display: "none" }}
              >
                <SearchInput
                  searchText={searchQuery}
                  handleSearch={handleSearchInputChange}
                />            </div>

              <div className="logo-box-gray">
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={handleReloadData}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </div>
              <div className="page-btn">
                <a
                  className={`btn btn-added-grid ${user?.permissions &&
                    hasPermission(user.permissions, "HRM", "Employee", "upload")
                    ? ""
                    : "disabled"
                    }`}
                  onClick={() => {
                    if (
                      user?.permissions &&
                      hasPermission(
                        user.permissions,
                        "HRM",
                        "Employee",
                        "upload"
                      )
                    ) {
                      setIsBulkUploadModalOpen(true);
                    }
                  }}
                  title={
                    !(
                      user?.permissions &&
                      hasPermission(
                        user.permissions,
                        "HRM",
                        "Employee",
                        "upload"
                      )
                    )
                      ? "No upload permission"
                      : ""
                  }
                >
                  Bulk upload
                </a>
              </div>
              <div className="page-btn">
                <a
                  className={`btn btn-added ${user?.permissions &&
                    hasPermission(user.permissions, "HRM", "Employee", "create")
                    ? ""
                    : "disabled"
                    }`}
                  onClick={() => {
                    if (
                      user?.permissions &&
                      hasPermission(
                        user.permissions,
                        "HRM",
                        "Employee",
                        "create"
                      )
                    ) {
                      handleReset();
                      setIsEdit(false);
                      setRecord(null);
                      setIsModalOpen(true);
                    }
                  }}
                  title={
                    !(
                      user?.permissions &&
                      hasPermission(
                        user.permissions,
                        "HRM",
                        "Employee",
                        "create"
                      )
                    )
                      ? "No create permission"
                      : ""
                  }
                >
                  <PlusCircle className="me-2" />
                  Employee
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Error Display */}
        {dataError && (
          <Alert
            message="Data Loading Error"
            description={dataError}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
            action={
              <Button size="small" onClick={() => loadEmployeeData()}>
                Retry
              </Button>
            }
          />
        )}

        {/* Search Filters */}
        <div className="card table-list-card-grid">
          <div
            className="card-body"
            style={{
              maxWidth: "100%",
              marginRight: "20px",
              backgroundColor: "transparent",
              borderRadius: "8px",
            }}
          >
            <div
              className="container mt-3 "
              style={{
                maxWidth: "100%",
                marginLeft: "20px",
                marginRight: "40px",
              }}
            >
              <div className="row d-flex flex-wrap align-items-start justify-content-between">
                <div className="col-12 col-md-3  text-start">
                  <label className="form-label">Employee Name</label>
                  <input
                    type="text"
                    value={searchName}
                    className="form-control"
                    onChange={(e) => {
                      setSearchName(e.target.value);
                    }}
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">EPF No</label>
                  <input
                    type="text"
                    value={searchEpfNumber}
                    className="form-control"
                    onChange={(e) => {
                      setSearchEpf(e.target.value);
                    }}
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Branch</label>
                  <AntSelect
                    value={searchBranch}
                    options={branchOptions}
                    className="select"
                    placeholder="Select Branch"
                    onChange={setSearchBranch}
                    allowClear
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Center</label>
                  <AntSelect
                    value={searchCenter}
                    options={center}
                    className="select"
                    placeholder="Select Center"
                    onChange={setSearchCenter}
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Status</label>
                  <AntSelect
                    value={resignStatus}
                    options={statusOptions}
                    className="select"
                    placeholder="Select Status"
                    onChange={handleResignStatusChange}
                    allowClear
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
              </div>
            </div>
            <div
              className="container mt-0 "
              style={{
                maxWidth: "100%",
                marginLeft: "20px",
                marginRight: "40px",
              }}
            >
              <div className="row d-flex flex-wrap align-items-start justify-content-between">
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Employee Type</label>
                  <AntSelect
                    value={empType}
                    onChange={setEmpType}
                    className="select"
                    options={employeeTypes}
                    placeholder="Select Employee Type"
                    allowClear
                    style={{ width: "100%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-3 mb-3 text-start">
                  <label className="form-label">Department</label>
                  <Select
                    value={selectedDepartment}
                    options={departmentOptions}
                    className="select"
                    placeholder="Select Department"
                    onChange={handleChangeDepartment}
                    style={{ width: "100%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-3 mb-3 text-start">
                  <label className="form-label">Date</label>
                  <RangePicker
                    format="YYYY-MM-DD"
                    onChange={onChange}
                    value={[
                      startDate ? dayjs(startDate) : null,
                      endDate ? dayjs(endDate) : null,
                    ]}
                    style={{ width: "100%" }}
                    allowClear
                  />
                </div>
                <div className="col-12 col-md-4 mb-3 text-start">
                  <label
                    className="form-label"
                    style={{ visibility: "hidden" }}
                  >
                    Hidden Label
                  </label>
                  <div className="d-flex align-items-center gap-2">
                    <button
                      disabled={
                        loading || loading2 || loading3 || loading4 || loading5
                      }
                      className="btn btn-submit"
                      onClick={handleSearch}
                      style={{ height: "38px", minWidth: "120px" }}
                    >
                      {loading || loading2 || loading3 || loading4 || loading5
                        ? "Search..."
                        : "Search"}
                    </button>
                    <button
                      disabled={
                        loading || loading2 || loading3 || loading4 || loading5
                      }
                      className="btn btn-cancel"
                      onClick={handleResetAllFilters}
                      style={{ height: "38px", minWidth: "120px" }}
                      title="Clear all filters and reload data"
                    >
                      Reset All
                    </button>
                    {loading || loading2 || loading3 || loading4 || loading5 ? (
                      <div className="spinner">
                        <div className="loading-circle"></div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Employee Table */}
        <div className="card table-list-card-grid">
          <div
            className="card-body"
            style={{
              maxWidth: "100%",
              marginRight: "20px",
              backgroundColor: "transparent",
              borderRadius: "8px",
            }}
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={employeeData.data}
                rowKey="_id"
                size={"small"}
                pagination={{
                  current: employeeData.page,
                  pageSize: employeeData.limit,
                  pageSizeOptions: ["5", "10", "20", "50"],
                  total: employeeData.total,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total) => `Total ${total} items`,
                }}
                onChange={handleTableChange}
                loading={loading3}
                rowClassName={() => "custom-row"}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Employee Modal - Separate Component */}
      <EmployeeModal
        isOpen={isModalOpen}
        onClose={handleCancel}
        isEdit={isEdit}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleEmployeeSubmit}
        loading={loading}
        titleOptions={titleOptions}
        gender={gender}
        branchOptions={branchOptions}
        center={center}
        departments={departments}
        designations={designations}
        shifts={shifts}
        nationalitiesOptions={nationalitiesOptions}
        employeeCategoryOptions={employeeCategoryOptions}
        employeeTypes={employeeTypes}
        payFrequencies={payFrequencies}
        sriLankaProvinces={sriLankaProvinces}
        allowances={allowances}
        allowanceCategories={allowanceCategories}
        deductionCategories={deductionCategories}
        education_and_training={education_and_training}
        uploadedPic={uploadedPic}
        setUploadedPic={setUploadedPic}
        documents={documents}
        setDocuments={setDocuments}
        hasShiftChanged={hasShiftChanged}
        setHasShiftChanged={setHasShiftChanged}
        record={record}
        fileList={fileList}
        setFileList={setFileList}
        deductionTypes={deductionTypes}
        compensationData={compensationData}
        setCompensationData={setCompensationData}
        onRefreshAllowanceCategories={async () => {
          try {
            let data = await getAllAllowances({ search: "", setLoading: setLoading5 });
            setAllowances(data.map((item) => ({ label: item.name, value: item._id })));
          } catch (err) { console.error("Error refreshing allowance categories:", err); }
        }}
        onRefreshDeductionTypes={async () => {
          try {
            const dtResponse = await fetchActiveDeductionTypes();
            setDeductionTypes(dtResponse?.data?.deduction || []);
          } catch (err) { console.error("Error refreshing deduction types:", err); }
        }}
      />

      {/* View Modal */}
      <EmployeeViewModal
        isVisible={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        formData={formData}
        uploadedPic={uploadedPic}
        documents={documents}
        shiftHistory={shiftHistory}
        resignData={resignData}
        allowanceData={allowanceData}
        totalBasic={totalBasic}
        budgetaryAllowance={budgetaryAllowance}
        education_and_training={education_and_training}
        departments={departments}
        designations={designations}
      />

      {/* Resign Modal */}
      <EmployeeResignModal
        isOpen={isResign}
        onClose={handleResignationClose}
        empRecord={empRecord}
        recordId={recordId}
        onResignSuccess={handleResignationSuccess}
      />

      {/* Reactivate Modal */}
      <EmployeeReactivateModal
        isOpen={isReactivate}
        onClose={handleReactivateClose}
        empRecord={empRecord}
        recordId={recordId}
        resignData={resignData}
        onReactivateSuccess={handleReactivateSuccess}
      />

      {/* Bulk Upload Modal */}
      <BulkUploadModal
        isOpen={isBulkUploadModalOpen}
        onClose={() => setIsBulkUploadModalOpen(false)}
      />

      {/* HRIS Integration Modal */}
      <HRISIntegration
        visible={hrisModalVisible}
        onCancel={() => setHrisModalVisible(false)}
      />

      {/* Delete Confirmation Modal */}
      <Modal
        zIndex={1200}
        open={isModalOpen2}
        onOk={() => {
          setIsModalOpen2(false);
          setReason("");
          setRecord("");
        }}
        width="45vw"
        onCancel={() => {
          setIsModalOpen2(false);
          setReason("");
          setRecord("");
        }}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <div className="card">
          <div className="card-body">
            <form>
              <div className="col-lg-12 col-md-12">
                <div className="mb-3">
                  <label className="form-label">Resigning Reason</label>
                  <textarea
                    rows={5}
                    type="text"
                    className="form-control"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer-btn">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  onClick={() => {
                    setIsModalOpen2(false);
                    setReason("");
                    setRecord("");
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-submit"
                  onClick={() => {
                    deleteEmployeeMethod({
                      id: record._id,
                      reason,
                      setLoading: setLoading4,
                      setIsDeleted,
                    });
                  }}
                  disabled={loading4}
                >
                  {loading4 ? "Deleting..." : "Delete"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      {/* PDF Preview Modal */}
      <Modal
        open={previewVisible}
        zIndex={1200}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        width={800}
        transitionName=""
      >
        <iframe
          src={previewFile}
          width="100%"
          height="600px"
          style={{ border: "none" }}
          title="PDF Preview"
        />
        <button
          type="button"
          className="btn btn-cancel"
          onClick={() => {
            setPreviewVisible(false);
          }}
        >
          Close
        </button>
      </Modal>
    </div>
  );
};

export default EmployeesGrid;